import * as React from "react";
import { PropsWithChildren } from "react";

import { observer } from "mobx-react";
import { Navigate } from "react-router-dom";
import { context } from "../../context/context";
import { notificationModel } from "../component/notifications/notification-model";
import { Permission } from "../../context/permission";
import { IWithRouterProps, withRouter } from "../component/hoc/withRouter";

interface IAuthenticatedRouteProps {
    permission: Permission;
}

@observer
export class AuthenticatedRoute extends React.Component<PropsWithChildren<IAuthenticatedRouteProps> & IWithRouterProps> {
    public render() {
        if (!context.isAuthenticated) {
            return this.unauthorizeRendering();
        }
        if (!context.hasPermission(this.props.permission)) {
            notificationModel.addErrorMessage("error.missingPermission", { userName: context.currentUser.name });
            return this.unauthorizeRendering();
        }

        return this.props.children;
    }

    private unauthorizeRendering() {
        return <Navigate to={"/login"} state={{ from: this.props.location.pathname }} replace />;
    }
}

export default withRouter(AuthenticatedRoute);
